import React from "react";
import Provider from "./components/provider";
import DataTable from "./components/table";
import Condition from "./components/condition";

import clsName from './index.module.scss'

const DctCaseAccount = ()=> {

  return (
    <Provider>
      <div className={clsName.wrapper}>
        <Condition/>
        <DataTable/>
      </div>
    </Provider>
  );
}

export default DctCaseAccount
